<script></script>

<footer>
  <div class="footer-wrapper">
    <div class="footer-logo-container">
      <h3 class="footer-logo">ICY PENGUIN</h3>
    </div>
    <div class="footer-menu-container">
      <ul>
        <h4 class="footer-title">MENU</h4>
        <li><a href="#">Buy a penguin</a></li>
        <li><a href="#">Roadmap</a></li>
        <li><a href="#">The NFT</a></li>
        <li><a href="#">Gallery</a></li>
        <li><a href="#">FAQ</a></li>
      </ul>
    </div>
    <div class="footer-social-container">
      <ul>
        <h4 class="footer-title">SOCIAL</h4>
        <li>
          <a href="#" target="_blank">Instagram</a>
        </li>
        <li>
          <a href="#" target="_blank">Twitter</a>
        </li>
        <li>
          <a href="#" target="_blank">Discord</a>
        </li>
      </ul>
    </div>
  </div>
  <div class="footer-copyright-wrapper">
    <p>©Icy Penguin 2021</p>
  </div>
</footer>

<style>
  footer {
    background-color: black;
    width: 100%;
    height: auto;
    position: relative;
    overflow: hidden;
  }

  footer a {
    color: #fff !important;
  }

  footer .footer-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    max-width: 750px;
  }

  footer .footer-wrapper .footer-logo-container {
    display: flex;
    align-items: center;
    margin-right: 2em;

    font-style: italic;
  }

  footer .footer-wrapper .footer-menu-container {
    margin: 2em;
  }

  footer .footer-wrapper .footer-menu-container h4,
  footer .footer-wrapper .footer-social-container h4 {
    font-style: italic;
  }

  footer .footer-wrapper .footer-social-container {
    margin: 2em;
  }

  footer .footer-copyright-wrapper {
    max-width: 750px;
    padding-bottom: 2em;
    margin: 0 auto;
    color: #fff;
    border: 0;
    border-top: 0.1em;
    border-style: solid;
    padding: 2em;
    padding-bottom: 2em;
  }

  @media (max-width: 768px) {
    footer .footer-wrapper {
      flex-direction: column;
      padding: 2em;
    }
    footer .footer-wrapper .footer-logo-container {
      margin: 0;
      margin-top: 2em;
    }
    footer .footer-wrapper .footer-menu-container {
      margin: 0;
      margin-top: 2em;
    }
    footer .footer-wrapper .footer-social-container {
      margin: 0;
      margin-top: 2em;
    }

    footer ul {
      padding: 0;
    }
  }
</style>
